import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, Dropdown, Layout } from 'antd';

import i18n from 'i18next';

import LogoImg from '../../assets/elrin-full-logo.png';
import {
  DEFAULT_LOGO,
  DEFAULT_LOGO_HEIGHT,
  DEFAULT_ENVIRONMENT,
  APP_ENV,
  MAHINDRA_SLUG,
  DEFAULT_FILE_PREFIX,
  SPL_SLUG,
} from '../../constant';
import { DownOutlined } from '@ant-design/icons';
import { useSession } from '../../Providers/SessionProviders';
import { useAxios } from '../../hooks';

const { Header: AntHeader } = Layout;

const StyledHeader = styled(AntHeader)`
  &.ant-layout-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #e2e3e;
    padding-inline: 30px;

    @media (max-width: 420px) {
      padding: 0px 15px;
    }
  }
`;

const LogoWrapper = styled.div`
  display: flex;
`;

const StyledImage = styled.img`
  // width: 122.5px;
  // height: ${DEFAULT_LOGO_HEIGHT}px;
  height: 35px;

  @media (max-width: 420px) {
    max-width: 250px;
  }
`;

const StyledLogoSample = styled.div`
  float: left;
  width: 120px;
  height: 31px;
  margin: 16px 24px 16px 0;
  background: rgb(192 172 172 / 30%);
`;

const Header = () => {
  const { currentUser, loginLoading, showLanguageDropdown, setCurrentUser } =
    useSession();
  const { fetch } = useAxios();
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    if (APP_ENV === DEFAULT_ENVIRONMENT.DEMO) {
      i18n.changeLanguage('en');
      setCurrentUser({ ...currentUser, language: 'en' });
    }
  }, []);

  useEffect(() => {
    if (currentUser?.company?.languages?.length > 0) {
      setLanguages(
        currentUser?.company?.languages.map((ele) => ({
          ...ele,
          key: ele.code,
          label: ele.text,
          onClick: () => onLanguageChange(ele.id, ele.code),
        })),
      );
    }
  }, [currentUser]);

  const getLanguageLabel = useCallback(() => {
    const selectedLanguage = languages.find(
      (ele) => currentUser?.language === ele.id,
    );
    return selectedLanguage?.label || 'English';
  }, [languages, currentUser]);

  const onLanguageChange = async (language, code) => {
    if (i18n.language === code) return;
    i18n.changeLanguage(code);
    setCurrentUser({ ...currentUser, language });
    if (APP_ENV !== DEFAULT_ENVIRONMENT.DEMO) {
      await fetch({
        method: 'PATCH',
        url: `/users/language/`,
        data: { language },
      });
    }
  };

  const logo = useMemo(() => {
    if (DEFAULT_LOGO) return DEFAULT_LOGO;
    if (currentUser?.company?.logo)
      return `${DEFAULT_FILE_PREFIX}${currentUser.company.logo}`;
    return LogoImg;
  }, [currentUser]);

  return (
    <StyledHeader>
      <LogoWrapper>
        {loginLoading ? (
          <StyledLogoSample />
        ) : (
          <>
            <StyledImage
              src={logo}
              alt="logo"
              style={
                currentUser?.company?.slug === SPL_SLUG
                  ? { height: '60px' }
                  : {}
              }
            />
            {/* {BACKY_ICON && <BackyLogo src={BACKY_ICON} alt="backy" />} */}
          </>
        )}
      </LogoWrapper>
      {showLanguageDropdown &&
        languages?.length > 0 &&
        currentUser?.company?.slug != MAHINDRA_SLUG && (
          <Dropdown menu={{ items: languages }} arrow={true}>
            <Button ghost type="primary">
              {getLanguageLabel()} <DownOutlined />
            </Button>
          </Dropdown>
        )}
    </StyledHeader>
  );
};

export default Header;
